'use client'

import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import {
  InlineDialog,
  InlineDialogHeader,
  InlineDialogBody,
  InlineDialogTitle,
  InlineDialogDescription,
} from './inline-dialog'
import { useTranslations } from 'next-intl'
import type { DemoEventSettings } from '../demo-types'

export interface SettingsPanelProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  settings: DemoEventSettings
  onToggleSetting: (key: keyof DemoEventSettings) => void
}

export function SettingsPanel({
  isOpen,
  onOpenChange,
  settings,
  onToggleSetting,
}: SettingsPanelProps) {
  const t = useTranslations('demo')
  return (
    <InlineDialog open={isOpen} onOpenChange={onOpenChange} className="max-w-md">
      <InlineDialogHeader onClose={() => onOpenChange(false)}>
        <InlineDialogTitle>{t('eventSettings')}</InlineDialogTitle>
        <InlineDialogDescription>
          {t('settingsDescription')}
        </InlineDialogDescription>
      </InlineDialogHeader>
      <InlineDialogBody>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('songRequests')}</Label>
            <Switch checked={settings.requestsEnabled} onCheckedChange={() => onToggleSetting('requestsEnabled')} />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('tips')}</Label>
            <Switch checked={settings.tipsEnabled} onCheckedChange={() => onToggleSetting('tipsEnabled')} />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('reactions')}</Label>
            <Switch checked={settings.reactionsEnabled} onCheckedChange={() => onToggleSetting('reactionsEnabled')} />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('feedback')}</Label>
            <Switch checked={settings.feedbackEnabled} onCheckedChange={() => onToggleSetting('feedbackEnabled')} />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('showQueueToAudience')}</Label>
            <Switch checked={settings.showQueue} onCheckedChange={() => onToggleSetting('showQueue')} />
          </div>
          <div className="flex items-center justify-between">
            <Label className="text-white">{t('showNowPlaying')}</Label>
            <Switch checked={settings.showNowPlaying} onCheckedChange={() => onToggleSetting('showNowPlaying')} />
          </div>
        </div>
      </InlineDialogBody>
    </InlineDialog>
  )
}
